document.addEventListener("DOMContentLoaded", function () {
  const productForm = document.querySelector("#custom-product-form");
  if (!productForm) return;

  const fileInput = document.querySelector("#attach-to-product");
  const noteTextarea = document.querySelector("#product-note");
  const submitBtn = productForm.querySelector('button[type="submit"]');
  const warningText = document.getElementById("custom-warning");
  const uploadContainer = document.querySelector(".custom-product-upload");

  // File upload handling
  let selectedFile = null;
  const previewContainer = document.getElementById("file-preview");
  const previewImage = document.getElementById("preview-image");
  const removeButton = document.getElementById("file-remove");
  const uploadLabel = document.getElementById("upload-label");


  if (noteTextarea) {
    noteTextarea.addEventListener("input", function () {
    updateSubmitState();
    });
  }
  // Function to check if form is valid
function updateSubmitState() {
  const hasFile = selectedFile !== null;
  const hasNote = noteTextarea && noteTextarea.value.trim().length > 0;


  if (hasFile || hasNote) {
  submitBtn.disabled = false;


  // Hide warning
  if (warningText) warningText.style.display = "none";
  } else {
  submitBtn.disabled = true;


  // Show warning
  if (warningText) warningText.style.display = "block";
  }
}

updateSubmitState()

  function handleFileSelect(file) {
    if (!file) return;

    // Validate file type
    if (!file.type.startsWith("image/")) {
      const errorMsg =
        window.translations?.custom_product?.invalid_file_type ||
        "Please select an image file.";
      alert(errorMsg);
      return;
    }

    // Validate file size (max 10MB)
    const maxSize = 10 * 1024 * 1024; // 10MB
    if (file.size > maxSize) {
      const errorMsg =
        window.translations?.custom_product?.file_too_large ||
        "File size must be less than 10MB.";
      alert(errorMsg);
      return;
    }

    selectedFile = file;

    updateSubmitState()

    // Show preview
    const reader = new FileReader();
    reader.onload = function (e) {
      // Hide label and show preview
      if (uploadLabel) {
        uploadLabel.style.display = "none";
      }
      if (previewContainer && previewImage) {
        previewImage.src = e.target.result;
        previewContainer.style.display = "flex";
      }
      if (uploadContainer) {
        uploadContainer.classList.add("has-file");
      }
    };
    reader.readAsDataURL(file);
  }

  // Handle remove button
  if (removeButton) {
    removeButton.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      selectedFile = null;
      updateSubmitState();
      if (fileInput) {
        fileInput.value = "";
      }

      // Hide preview and show label again
      if (previewContainer) {
        previewContainer.style.display = "none";
      }
      if (uploadLabel) {
        // Remove inline style to restore original CSS flex display
        uploadLabel.style.display = "";
      }
      if (uploadContainer) {
        uploadContainer.classList.remove("has-file");
      }
    });
  }

  // File input change
  if (fileInput) {
    fileInput.addEventListener("change", function (e) {
      const file = e.target.files[0];
      handleFileSelect(file);
    });

    // Drag and drop
    if (uploadContainer) {
      uploadContainer.addEventListener("dragover", function (e) {
        e.preventDefault();
        uploadContainer.classList.add("drag-over");
      });

      uploadContainer.addEventListener("dragleave", function (e) {
        e.preventDefault();
        uploadContainer.classList.remove("drag-over");
      });

      uploadContainer.addEventListener("drop", function (e) {
        e.preventDefault();
        uploadContainer.classList.remove("drag-over");
        const file = e.dataTransfer.files[0];
        if (file) {
          handleFileSelect(file);
          // Set file to input for form submission
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(file);
          fileInput.files = dataTransfer.files;
        }
      });

      // Prevent image dragging
      uploadContainer.addEventListener("dragstart", function (e) {
        if (e.target.tagName === "IMG") {
          e.preventDefault();
        }
      });
    }
  }

  // Form submission
  productForm.addEventListener("submit", async function (e) {
    e.preventDefault();

    if (!submitBtn) return;

    const originalText = submitBtn.innerHTML;
    submitBtn.disabled = true;
    
    // Show appropriate loading text based on redirect setting
    if (window.customProductRedirectToCheckout) {
      submitBtn.textContent =
        window.translations?.custom_product?.processing || "Processing...";
    } else {
      submitBtn.textContent =
        window.translations?.custom_product?.adding || "Adding...";
    }

    try {
      const formData = new FormData(productForm);
      const variantId = formData.get("id");
      const quantity = parseInt(formData.get("quantity")) || 1;

      if (!variantId) {
        throw new Error("Variant ID is required");
      }

      // Get note text
      const note = noteTextarea ? noteTextarea.value.trim() : "";

      // Build properties object for cart attributes
      const properties = {};

      // Add note if provided
      if (note) {
        properties["Note"] = note;
      }

      // Add file if selected - convert to base64 for storage in cart properties
      if (selectedFile) {
        // Read file as base64
        const reader = new FileReader();
        reader.onload = async function (e) {
          const base64Image = e.target.result;
          // Store both filename and base64 data
          properties["Custom Image"] = selectedFile.name;
          properties["Custom Image Data"] = base64Image;

          // Submit to cart with original text
          submitToCart(variantId, quantity, properties, originalText);
        };
        reader.readAsDataURL(selectedFile);
        return; // Exit early, will continue in reader.onload
      }

      // No file, submit immediately
      submitToCart(variantId, quantity, properties, originalText);
    } catch (error) {
      handleFormError(error, submitBtn, originalText);
    }
  });

  // Extract cart submission to separate function
  async function submitToCart(variantId, quantity, properties, originalText) {
    if (!submitBtn || !originalText) return;

    try {
      // Create items array with properties
      const items = [
        {
          id: parseInt(variantId),
          quantity: quantity,
          properties:
            Object.keys(properties).length > 0 ? properties : undefined,
        },
      ];

      const cartUrl =
        (window.routes && window.routes.cart_add_url
          ? window.routes.cart_add_url
          : "/cart/add") + ".js";

      const response = await fetch(cartUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: items }),
      });

      const data = await response.json();

      if (response.ok) {
        // Publish cart update event
        if (
          typeof publish !== "undefined" &&
          typeof PUB_SUB_EVENTS !== "undefined"
        ) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            action: "add",
            variant: data,
            properties: properties,
            product: window.customProductData,
          });
        }

        // Check if redirect to checkout is enabled
        if (window.customProductRedirectToCheckout) {
          // Redirect to checkout immediately
          window.location.href = "/checkout";
          return; // Exit early, don't reset form or button
        }

        // Reset form (only if not redirecting to checkout)
        if (selectedFile) {
          fileInput.value = "";
          selectedFile = null;
          if (previewContainer) {
            previewContainer.style.display = "none";
          }
          if (uploadLabel) {
            // Remove inline style to restore original CSS flex display
            uploadLabel.style.display = "";
          }
          if (uploadContainer) {
            uploadContainer.classList.remove("has-file");
          }
        }
        if (noteTextarea) {
          noteTextarea.value = "";
        }

        const addedText =
          window.translations?.custom_product?.added || "Added!";
        submitBtn.textContent = addedText;

        // Reset button after delay
        setTimeout(() => {
          if (submitBtn && originalText) {
            submitBtn.innerHTML = originalText;
            submitBtn.disabled = false;
          }
        }, 1000);
      } else {
        throw new Error(data.description || "Failed to add to cart");
      }
    } catch (error) {
      handleFormError(error, submitBtn, originalText);
    }
  }

  function handleFormError(error, submitBtn, originalText) {
    console.error("Error:", error);

    // Publish error event
    if (
      typeof publish !== "undefined" &&
      typeof PUB_SUB_EVENTS !== "undefined"
    ) {
      publish(PUB_SUB_EVENTS.cartError, {
        error: error.message,
        context: "custom-product-form",
        productId: window.customProductData?.id,
      });
    }

    if (submitBtn && originalText) {
      submitBtn.textContent =
        window.translations?.custom_product?.error_try_again ||
        "Error - Try Again";
      setTimeout(() => {
        submitBtn.innerHTML = originalText;
        submitBtn.disabled = false;
      }, 2000);
    }
  }
});
